import { Typography } from '@mantine/core';
import { generateHTML } from '@tiptap/html';
import { JSONContent } from '@tiptap/react';
import { useMemo } from 'react';

import classes from './RichTextViewer.module.css';
import { richTextEditorExtensions } from './richTextEditor.consts';

type Props = {
  content: JSONContent;
};

const filterSequentialHardBreaks = (node: JSONContent): JSONContent => {
  if (!node.content?.length) return node;

  const filtered = node.content.map((item) => {
    if (item.type !== 'paragraph' || !item.content?.length) return item;

    const deduplicated: JSONContent[] = [];
    let lastWasHardBreak = false;

    for (const child of item.content) {
      if (child.type === 'hardBreak') {
        if (!lastWasHardBreak) {
          deduplicated.push(child);
          lastWasHardBreak = true;
        }
      } else {
        deduplicated.push(child);
        lastWasHardBreak = false;
      }
    }

    return { ...item, content: deduplicated };
  });

  return { ...node, content: filtered };
};

export const ZorroRichTextViewer = ({ content }: Props) => {
  const htmlContent = useMemo(() => {
    const cleanedContent = filterSequentialHardBreaks(content);
    return generateHTML(cleanedContent, richTextEditorExtensions);
  }, [content]);

  return (
    <Typography className={classes.viewer}>
      <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
    </Typography>
  );
};
